import React, { useEffect, useCallback, useState } from 'react'
import { flushSync } from 'react-dom'
import { DateRangePicker } from "vanillajs-datepicker"

const DateRangeInput = ({index, name, fieldname, onChange, value, onEnterPress}) => {
    const TYPE = "datetime";

    const handleChangeDate = useCallback((event) => {
        const elem = document.getElementById(`datetime-${index}`);
        if (elem && elem.rangepicker) {
            onChange(elem.rangepicker, TYPE, fieldname);
        }
    }, [index, TYPE, fieldname, onChange]);

    const [invalid, setInvalid] = useState(false);
    const [warning, setWarning] = useState("");

    // Helper to check for 2-digit year
    const hasTwoDigitYear = (dateStr) => {
        if (!dateStr) return false;
        // Looks for valid date format
        const match = dateStr.match(/^(0?[1-9]|1[0-2])([/-])(0?[1-9]|[12]\d|3[01])\2\d{4}$/);
        if (!match) return true;
        return false
    };

    const validateInputs = () => {
        const elem = document.getElementById(`datetime-${index}`);
        if (!elem) return false;
        const startInput = elem.querySelector(`#datetime-${index}-start`);
        const endInput = elem.querySelector(`#datetime-${index}-end`);
        let invalidYear = false;
        let msg = "";
        if (startInput && hasTwoDigitYear(startInput.value)) {
            invalidYear = true;
            msg = "Start date must be of format MM/DD/YYYY";
        } else if (endInput && hasTwoDigitYear(endInput.value)) {
            invalidYear = true;
            msg = "End date must be of format MM/DD/YYYY";
        }
        setInvalid(invalidYear);
        setWarning(msg);
        elem.rangepicker.datepickers.forEach(picker => picker.hide());
        return invalidYear;
    };

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();

            // Validate before committing
            if (validateInputs()) {
                return;
            }

            const elem = document.getElementById(`datetime-${index}`);
            if (elem && elem.rangepicker) {
                elem.rangepicker.datepickers.forEach(picker => picker.hide());
                flushSync(() => {
                    onChange(elem.rangepicker, TYPE, fieldname);
                });
            }

            onEnterPress?.();
        }
    }, [index, TYPE, fieldname, onChange, onEnterPress]);

    useEffect(() => {
        const elem = document.getElementById(`datetime-${index}`);
        if (elem && elem.rangepicker === undefined) {
            new DateRangePicker(elem, {
                buttonClass: 'btn',
                clearButton: true,
                allowOneSidedRange: true,
                minDate: new Date(1900, 0, 1),
            });
        }
    }, [index]);

    useEffect(() => {
        // Initialize date range picker
        const elem = document.getElementById(`datetime-${index}`);
        if (elem) {
            elem.addEventListener('changeDate', handleChangeDate);
        }
        
        return () => {
            if (elem) {
                elem.removeEventListener('changeDate', handleChangeDate);
            }
        };
    }, [index, fieldname, onChange, handleChangeDate]);

    useEffect(() => {
        const elem = document.getElementById(`datetime-${index}`);
        if (!elem) return;

        const startInput = elem.querySelector(`#datetime-${index}-start`);
        const endInput = elem.querySelector(`#datetime-${index}-end`);

        if (startInput) {
            startInput.addEventListener('keydown', handleKeyDown);
            startInput.addEventListener('blur', validateInputs);
        }
        if (endInput) {
            endInput.addEventListener('keydown', handleKeyDown);
            endInput.addEventListener('blur', validateInputs);
        }

        return () => {
            if (startInput) {
                startInput.removeEventListener('keydown', handleKeyDown);
                startInput.removeEventListener('blur', validateInputs);
            }
            if (endInput) {
                endInput.removeEventListener('keydown', handleKeyDown);
                endInput.removeEventListener('blur', validateInputs);
            }
        };
    }, [index, handleKeyDown]);

    useEffect(() => {
        const elem = document.getElementById(`datetime-${index}`);
        if (elem && elem.rangepicker && !value) elem.rangepicker.setDates({clear: true}, {clear: true});
    }, [index, value]);
    
    return (
        <div className="side-input mt-2 mb-2">
            <div>
                <label className="mb-0" htmlFor={`datetime-${index}-start`}>{name}</label>
                <div className="input-group mb-3 date input-daterange" id={`datetime-${index}`}>
                    <input className={`form-control datepicker-input${invalid ? ' is-invalid' : ''}`} type="text" name="start" id={`datetime-${index}-start`} />
                    <span className="input-group-text">to</span>
                    <label className="mb-0 sr-only" htmlFor={`datetime-${index}-end`}>{name}</label>
                    <input className={`form-control datepicker-input datepicker-end-input${invalid ? ' is-invalid' : ''}`} type="text" name="end" id={`datetime-${index}-end`} />
                </div>
                {invalid && (
                    <div className="text-danger small mt-1">{warning}</div>
                )}
            </div>
        </div>
    )
}

export default DateRangeInput